"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("material-ui/Checkbox"));
var _TextField = _interopRequireDefault(require("material-ui/TextField"));
var _SelectField = _interopRequireDefault(require("material-ui/SelectField"));
var _MenuItem = _interopRequireDefault(require("material-ui/MenuItem"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./InputText.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var PartialDate = /*#__PURE__*/function (_React$Component) {
  _inherits(PartialDate, _React$Component);
  var _super = _createSuper(PartialDate);
  function PartialDate(props) {
    var _this;
    _classCallCheck(this, PartialDate);
    _this = _super.call(this, props);
    // console.log('Setting def: ', props.valueFromInput || props.defaultValue || '');
    _this.state = {
      value: props.value || props.defaultValue || ""
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(PartialDate, [{
    key: "handleChange",
    value: function handleChange(param, value) {
      if (this.state[param] !== value) {
        // const newValue =
        //   param === "month" || param === "day" ? (val ? val + 1 : val) : val;
        this.setState({
          value: _objectSpread(_objectSpread({}, this.state.value), {}, _defineProperty({}, param, value))
        });
        if (typeof this.props.handleInputChange !== "undefined") {
          this.props.handleInputChange(this.props.name, _defineProperty({}, param, value));
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // console.log('componentWillReceiveProps - state',this.props.name, this.props.defaultValue, ' - nextProps', nextProps.defaultValue);
      if (this.props.value !== nextProps.value) {
        // console.log('change happening');
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var months = [{
        value: 1,
        label: "Jan"
      }, {
        value: 2,
        label: "Feb"
      }, {
        value: 3,
        label: "Mar"
      }, {
        value: 4,
        label: "Apr"
      }, {
        value: 5,
        label: "May"
      }, {
        value: 6,
        label: "Jun"
      }, {
        value: 7,
        label: "Jul"
      }, {
        value: 8,
        label: "Aug"
      }, {
        value: 9,
        label: "Sep"
      }, {
        value: 10,
        label: "Oct"
      }, {
        value: 11,
        label: "Nov"
      }, {
        value: 12,
        label: "Dec"
      }];
      var hasLabel = this.props.hasLabel;
      var isTextarea = !!this.props.multiLine;
      var floatingLabelStyle = this.props.styleName === "plain" ? _objectSpread({
        padding: "4px 9px",
        color: "rgba(0, 0, 0, 0.4)",
        top: 10
      }, this.props.labelStyle) : this.props.labelStyle;
      var floatingLabelFocusStyle = this.props.styleName === "plain" ? {
        top: 21
      } : undefined;
      var style = this.props.styleName === "plain" ? _objectSpread({
        height: 50
      }, this.props.inputStyle) : this.props.inputStyle;

      // console.log('textareaStyle', this.props.name, hasLabel, this.props.label);

      var inputStyle = this.props.styleName === "plain" ? isTextarea ? {
        height: 96
      } : {
        backgroundColor: "#f6f6f6",
        fontSize: 13,
        marginTop: 0,
        borderRadius: 4,
        padding: hasLabel ? "16px 8px 0px 8px" : "0 9px"
      } : null;
      var textareaInputStyle = this.props.styleName === "plain" ? {
        backgroundColor: "#f6f6f6",
        borderRadius: 4,
        // height: 50,
        fontSize: 13,
        padding: hasLabel ? "20px 7px 6px 7px" : "13px 9px",
        marginTop: 0,
        marginBottom: 0
      } : null;
      var inputStyleSelect = this.props.styleName === "plain" ? {
        backgroundColor: "#f6f6f6",
        fontSize: 13,
        marginTop: 0,
        borderRadius: 4,
        width: "100%",
        height: 50,
        boxSizing: "border-box",
        padding: "0 0 0 11px"
      } : this.props.style;
      var underlineStyle = this.props.styleName === "plain" ? {
        display: "none"
      } : this.props.underlineStyle;
      var floatingLabelStyleSelect = this.props.styleName === "plain" ? {
        top: 27,
        fontSize: 14,
        color: "rgba(0, 0, 0, 0.4)"
      } : undefined;
      var menuStyle = this.props.styleName === "plain" ? {
        marginTop: 5
      } : this.props.menuStyle;
      var days = Array(31).fill();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "cms-input-text partial-date-container",
        key: this.props.id
      }, hasLabel ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "label-container"
      }, this.props.label) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "inputs-container"
      }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        type: "text",
        className: "cms-input-text ".concat(this.props.required && (this.state.value === null || this.state.value === undefined || this.state.value === "") ? "invalid-input" : ""),
        id: this.props.id,
        underlineShow: this.props.styleName !== "plain",
        disabled: this.props.disabled,
        name: this.props.name + "Year",
        value: this.state.value ? this.state.value.year : "",
        floatingLabelText: "Year",
        floatingLabelFixed: true,
        floatingLabelStyle: floatingLabelStyle,
        floatingLabelFocusStyle: floatingLabelFocusStyle,
        floatingLabelShrinkStyle: floatingLabelFocusStyle,
        fullWidth: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange("year", value);
        },
        style: style,
        inputStyle: inputStyle,
        hintText: this.props.placeholder
      }), /*#__PURE__*/_react["default"].createElement(_SelectField["default"], {
        value: this.state.value ? this.state.value.month : undefined,
        onChange: function onChange(e, value) {
          return _this2.handleChange("month", value);
        },
        className: "select-input",
        style: inputStyleSelect,
        autoWidth: true,
        underlineStyle: underlineStyle,
        floatingLabelText: "Month",
        floatingLabelStyle: floatingLabelStyleSelect,
        menuStyle: menuStyle,
        listStyle: this.props.listStyle,
        selectedMenuItemStyle: this.props.selectedMenuItemStyle,
        menuItemStyle: this.props.menuItemStyle,
        floatingLabelFixed: true
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: "null-value",
        value: null,
        primaryText: "",
        innerDivStyle: this.props.selectedMenuItemStyle
      }), months.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: index,
          value: option.value,
          primaryText: option.label,
          innerDivStyle: _this2.props.selectedMenuItemStyle
        });
      })), /*#__PURE__*/_react["default"].createElement(_SelectField["default"], {
        value: this.state.value ? this.state.value.day : undefined,
        onChange: function onChange(e, value) {
          return _this2.handleChange("day", value);
        },
        className: "select-input",
        autoWidth: true,
        style: inputStyleSelect,
        underlineStyle: underlineStyle,
        floatingLabelText: "Day",
        floatingLabelStyle: floatingLabelStyleSelect,
        menuStyle: menuStyle,
        listStyle: this.props.listStyle,
        selectedMenuItemStyle: this.props.selectedMenuItemStyle,
        menuItemStyle: this.props.menuItemStyle,
        floatingLabelFixed: true
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: "null-value",
        value: null,
        primaryText: "",
        innerDivStyle: this.props.selectedMenuItemStyle
      }), Array(31).fill().map(function (_, i) {
        var day = i + 1;
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: day,
          value: day,
          primaryText: day,
          innerDivStyle: _this2.props.selectedMenuItemStyle
        });
      })), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        className: "cms-checkbox",
        checked: this.state.value ? !this.state.value.era : false,
        labelPosition: "right",
        label: "BCE",
        onCheck: function onCheck(e) {
          var newValue = e.target.checked ? 0 : 1;
          _this2.handleChange("era", newValue);
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          clear: "both"
        }
      }));
    }
  }]);
  return PartialDate;
}(_react["default"].Component);
PartialDate.defaultProps = {
  inputStyle: {},
  labelStyle: {
    fontSize: 14
  },
  required: false,
  styleName: "material",
  disabled: false
};
PartialDate.propTypes = {
  hasLabel: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  inputStyle: _propTypes["default"].object,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].node]),
  labelStyle: _propTypes["default"].object,
  name: _propTypes["default"].string,
  handleInputChange: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  styleName: _propTypes["default"].string,
  value: _propTypes["default"].any,
  defaultValue: _propTypes["default"].any
};
var _default = PartialDate;
exports["default"] = _default;